// eslint-disable-next-line
// @ts-nocheck
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Switch,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import Loading from '../../components/Loading';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import { useDeleteOfferDetailMutation, useGetAllOfferDetailMutation } from '../../store/api/offerApi';
import { getOffer, getOfferTotalRecord, setOffer } from '../../store/state/offerSlice';
import { checkPermissions } from '../../sections/@dashboard/parkingspaces/utility';
import { PERMISSION } from '../../utils/userPermission';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Offer Name', alignRight: false },
  { id: 'offerFor', label: 'Offer For', alignRight: false },
  { id: 'percentage', label: 'Offer Amount', alignRight: false },
  { id: 'validIn', label: 'Offer Start Date', alignRight: false },
  { id: 'validTill', label: 'Offer End Date', alignRight: false },
  { id: 'promo', label: 'Promo Code', alignRight: false },
  { id: 'OffersStatus', label: 'Offer Status', alignRight: false },
];

// ----------------------------------------------------------------------

export default function Offers() {
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const [offersData, setOffersData] = useState([]);
  const [getAllOfferDetail, getAllOfferDetailResponse] = useGetAllOfferDetailMutation();
  const offerTotalRecord = useAppSelector(getOfferTotalRecord);
  const getOfferData = useAppSelector(getOffer);
  const [deleteOfferDetail, deleteResponse] = useDeleteOfferDetailMutation();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [vendorId, setVendorId] = useState<number>();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (getOfferData) {
      setOffersData(getOfferData);
    }
  }, [getOfferData]);

  useEffect(() => {
    getAllOfferDetail({
      token: token.token,
      payload: {
        page: page,
        orderBy: order,
        offset: rowsPerPage,
      },
    });
    setFilterName('');
  }, []);

  useEffect(() => {
    if (getAllOfferDetailResponse.isSuccess) {
      dispatch(setOffer(getAllOfferDetailResponse.data));
    }
    if (getAllOfferDetailResponse.isError) {
      let errorData: any = getAllOfferDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllOfferDetailResponse.isSuccess, getAllOfferDetailResponse.isError]);

  useEffect(() => {
    if (deleteResponse.isSuccess) {
      getAllOfferDetail({
        token: token.token,
        payload: {
          page: page,
          orderBy: order,
          offset: rowsPerPage,
        },
      });
      toast.success('Vendor updated successfully');
    }
    if (deleteResponse.isError) {
      let errorData: any = deleteResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [deleteResponse.isSuccess, deleteResponse.isError]);

  const filteredUsers = offersData;
  const isUserNotFound = filteredUsers.length === 0;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllOfferDetail({
      token: token.token,
      payload: { offset: rowsPerPage, page: newPage, orderBy: order },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllOfferDetail({
      token: token.token,
      payload: { offset: event.target.value, page: 0, orderBy: order },
    });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
      getAllOfferDetail({
        token: token.token,
        payload: { offset: rowsPerPage, page: page, searchValue: event.target.value },
      });
  };

  const handleDelete = () => {
    setOpen(false);
    deleteOfferDetail({
      id: vendorId,
      token: token.token,
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const cancelDelete = () => {
    setOpen(false);
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  return (
    <Page title="Offer Overview">
      {checkPermissions(PERMISSION.OFFERS_ALL, token.permissions) ? (
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
            <Typography variant="h4" gutterBottom>
              Offer Overview
            </Typography>
            <Button
              style={{ color: 'white', backgroundColor: '#E23744' }}
              variant="contained"
              onClick={() => {
                navigate('/dashboard/add-or-update-offers', { state: { editMode: false } });
              }}
              startIcon={<Iconify icon="eva:plus-fill" />}
              size="large"
            >
              Add
            </Button>
          </Stack>
          <Card>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <BookingListToolbar
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
                placeholder={'Search Offers by Title'}
              />
            </Stack>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <AllParkingsListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={offersData.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.length > 0 &&
                      filteredUsers.map((row) => {
                        const {
                          id,
                          name,
                          validInName,
                          offerValue,
                          expiryDate,
                          offerType,
                          status,
                          offerTitle,
                          promoCode,
                          startDate,
                        } = row;
                        const isItemSelected = selected.indexOf(name) !== -1;

                        return (
                          <TableRow
                            hover
                            key={id.toString()}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                          >
                            <TableCell
                              align="left"
                              onClick={() => {
                                navigate('/dashboard/add-or-update-offers', {
                                  state: { editMode: true, editData: row },
                                });
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <Typography fontWeight="bold" variant="subtitle2" color={'blue'}>
                                {offerTitle}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="normal" variant="subtitle2">
                                {validInName}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="normal" variant="subtitle2">
                                {offerType === 'OTPRCNT' ? `${offerValue}%` : `₹${offerValue}`}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="normal" variant="subtitle2">
                                {format(new Date(startDate), 'dd/MM/yyyy')}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="normal" variant="subtitle2">
                                {format(new Date(expiryDate), 'dd/MM/yyyy')}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="normal" variant="subtitle2">
                                {promoCode}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Stack direction="row" alignItems="center">
                                <Switch
                                  checked={status}
                                  onClick={(e) => {
                                    setVendorId(id);
                                    handleOpen();
                                  }}
                                />
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>

                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={offerTotalRecord || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
          {open && (
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                  Are you sure?
                </Typography>
                <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                  <Button
                    variant="contained"
                    onClick={cancelDelete}
                    sx={{ margin: '10px' }}
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                  >
                    No
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleDelete}
                    sx={{ margin: '10px' }}
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                  >
                    Yes
                  </Button>
                </Stack>
              </Box>
            </Modal>
          )}
          {getAllOfferDetailResponse.isLoading || deleteResponse.isLoading ? <Loading /> : null}
        </Container>
      ) : null}
    </Page>
  );
}
